// Function to get the stored language from local storage
function getStoredLanguage() {
    return localStorage.getItem('language') || '{{@site.locale}}';
}

// Function to set the stored language in local storage
function setStoredLanguage(locale) {
    localStorage.setItem('language', locale);
}

// Initial setup: get the stored language and set the lang attribute
document.documentElement.lang = getStoredLanguage();

document.getElementById('language-switcher').addEventListener('click', function() {
    var currentLocale = getStoredLanguage();
    var newLocale = currentLocale === "en" ? "pt" : "en";
    
    // Toggle language on the root HTML element
    document.documentElement.lang = newLocale;

    // Set the new locale in local storage
    setStoredLanguage(newLocale);
    console.log(currentLocale)
    console.log(document.documentElement.lang)
    // Reload the page to reflect the language change
    location.reload();
});